import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwIfAlreadyLoaded } from './module-import-guard';
import {
  AnalyticsService,
  LayoutService,
  PlayerService,
  StateService,
  AuthService,
  EmployeeService,
  AddressService,
  AService,
  UserBiddingService,
  PlanBiddingService,
  CreditOnlineService,
  CashService,
  PermisstionBiddingService,
  ResultBiddingService,
  IService,
  JService,
  KService,
  LService,
  MService,
  NService,
  UserService,
  CompanyService,
  MainTenanceService,
  SettingService,
  CarService,
  BookingService,
  CareerService,
  CheckVehService,
  CommonService,
  ContactUsService,
  CrmContactUserService,
  EmpUserManagementService,
  ImgLoginService,
  InterestService,
  NotificationService,
  PlanBiddingOnlineService,
  PolicyService,
  QAndAService,
  SellerService,
  TermService,
  UserProfileService,
  AuthGuard,
  BrandService
} from './utils';
import { UserData } from './data/users';
import { PromotionService } from './utils/promotion.service';




export const NB_CORE_PROVIDERS = [
  AnalyticsService,
  LayoutService,
  PlayerService,
  StateService,
  AuthService,
  EmployeeService,
  AddressService,
  AService,
  UserBiddingService,
  PlanBiddingService,
  CreditOnlineService,
  CashService,
  PermisstionBiddingService,
  ResultBiddingService,
  IService,
  JService,
  KService,
  LService,
  MService,
  NService,
  UserService,
  CompanyService,
  MainTenanceService,
  SettingService,
  PromotionService,
  CarService,
  BookingService,
  CareerService,
  CheckVehService,
  CommonService,
  ContactUsService,
  CrmContactUserService,
  EmpUserManagementService,
  ImgLoginService,
  InterestService,
  NotificationService,
  PlanBiddingOnlineService,
  PolicyService,
  QAndAService,
  SellerService,
  TermService,
  UserProfileService,
  AuthGuard,
  BrandService
];

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    };
  }
}
